import NextMedicationForm from './NextMedicationForm';

export default NextMedicationForm;
